import useWindowWidth from '../../../../../hooks/useWindowWidth'

import style from './style.module.css'

// SVG ICONS
import Arrow4Icon from '../../../../../assets/svgs/Arrow4'
import Filter2Icon from '../../../../../assets/svgs/Filter2'
import CheckBox2Icon from '../../../../../assets/svgs/Checkbox2'
import ArrowDown2Icon from '../../../../../assets/svgs/ArrowDown2'
import CompanyIcon from '../../../../../assets/svgs/Company'
import PinIcon from '../../../../../assets/svgs/Pin'
import IndustryIcon from '../../../../../assets/svgs/Industry'
import PeopleIcon from '../../../../../assets/svgs/People'
import Bag2Icon from '../../../../../assets/svgs/Bag2'
import StatisticsIcon from '../../../../../assets/svgs/Statistics'
import CrossSpotlightIcon from '../../../../../assets/svgs/CrossSpotlight'

const Filter = ({ isFilterOpen, setIsFilterOpen }) => {
  const isMobile = useWindowWidth() <= 768

  const handleOpen = () => {
    setIsFilterOpen((prev) => !prev)
  }

  return (
    <div className={`${style.filter} ${isFilterOpen && style.filter_open}`}>
      {isMobile && (
        <div className={`${style.filter__closeButton}`} onClick={handleOpen}>
          <CrossSpotlightIcon />
        </div>
      )}

      <div className={`${style.filter__openButton}`} onClick={handleOpen}>
        <Arrow4Icon />
      </div>

      <nav className={style.filter__nav}>
        <div
          className={style.filter__mainIcon}
          onClick={() => !isMobile && handleOpen()}
        >
          <div className={style.filter__mainIcon_block}>
            <Filter2Icon />
            <span>Filter</span>
          </div>
          <div className={style.filter__mainIcon_line}></div>
        </div>

        <div className={style.filter__checkSaved}>
          <CheckBox2Icon />
          <span className={style.filter__checkSaved_text}>See saved (12)</span>
        </div>

        <ul className={style.filter__list}>
          <li className={style.filter__item}>
            <div className={style.filter__item_label}>
              <CompanyIcon />
              <span>Company</span>
            </div>
            <ArrowDown2Icon />
          </li>

          <li className={style.filter__item}>
            <div className={style.filter__item_label}>
              <PinIcon />
              <span>Location</span>
            </div>
            <ArrowDown2Icon />
          </li>

          <li className={style.filter__item}>
            <div className={style.filter__item_label}>
              <IndustryIcon />
              <span>Industry</span>
            </div>
            <ArrowDown2Icon />
          </li>

          <li className={style.filter__item}>
            <div className={style.filter__item_label}>
              <PeopleIcon />
              <span>Company size</span>
            </div>
            <ArrowDown2Icon />
          </li>

          <li className={style.filter__item}>
            <div className={style.filter__item_label}>
              <Bag2Icon />
              <span>Company type</span>
            </div>
            <ArrowDown2Icon />
          </li>
        </ul>

        <div
          className={`${style.filter__mainIcon} ${style.statistics}`}
          onClick={handleOpen}
        >
          <div className={style.filter__mainIcon_block}>
            <StatisticsIcon />
            <span>Statistics</span>
          </div>
          <div className={style.filter__mainIcon_line}></div>
        </div>

        <ul className={style.statistics__list}>
          <li className={style.statistics__item}>
            <span className={style.statistics__item_number}>50</span>
            <span className={style.statistics__item_text}>visited company</span>
          </li>

          <li className={style.statistics__item}>
            <span className={style.statistics__item_number}>28</span>
            <span className={style.statistics__item_text}>interactions</span>
          </li>

          <li className={style.statistics__item}>
            <span className={style.statistics__item_number}>44</span>
            <span className={style.statistics__item_text}>something else</span>
          </li>
        </ul>

        <p className={style.nav__scroll_text}>Scroll to see more</p>
      </nav>
    </div>
  )
}

export default Filter
